// extracted by mini-css-extract-plugin
module.exports = {"bmSelect":"CustomSelect_bmSelect__DT31e"};